// extracted by mini-css-extract-plugin
export var contacts = "styles-module--contacts--EcSbG";
export var content = "styles-module--content--EZX9-";
export var link = "styles-module--link--zPTHA";
export var title = "styles-module--title--hOtSl";